"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConfiguration = void 0;
const types_1 = require("./types");
const configuration = Object.freeze({
    storageKey: 'ocean-connect-storage-key',
    [types_1.ProviderType.INJECTED]: {}
});
function getConfiguration() {
    return configuration;
}
exports.getConfiguration = getConfiguration;
//# sourceMappingURL=configuration.js.map